export default {dataUrl:'https://a.egwwritings.org/cf/', postUrl:'https://a.egwwritings.org/cf/'}



// WEBPACK FOOTER //
// ./src/appconfig.js